import { FC, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import Button from 'components/ui/Button/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { getTextAlignStyle } from 'utils/utils';
import MaximizeModal from 'components/shared/MaximizeModal';
import ScreenshotSupport from 'components/shared/ScreenshotSupport';
import useDraggableModal from 'hooks/useDraggableModal';
import withErrorBoundary from 'components/shared/withErrorBoundary';

interface MoreDetailsModalProps {
  dealModel: any;
  onClose: () => void;
}

const MoreDetailsModal: FC<MoreDetailsModalProps> = ({
  dealModel: { deal, description },
  onClose,
}) => {
  const [t] = useTranslation();
  const modalOverlayRef = useRef<HTMLDivElement>(null);
  const { modalRef, modalStyle, dragHandleProps, isDragging } = useDraggableModal(true);

  return (
    <div
      className="modal-overlay modal-overlay-top modal-maximizable"
      ref={modalOverlayRef}
      onClick={(e) => e.target === e.currentTarget && onClose()}
    >
      <div ref={modalRef} className={'modal modal-sm active'} style={modalStyle}>
        <div
          className={'modal-title draggable-modal-handle' + (isDragging ? ' dragging' : '')}
          {...dragHandleProps}
        >
          <h5 className="title">{deal.dealTitle}</h5>
          <div data-no-drag="true">
            <ScreenshotSupport />
            <MaximizeModal modalOverlayRef={modalOverlayRef} />
            <FontAwesomeIcon icon={faTimes} onClick={() => onClose()} />
          </div>
        </div>
        <div className="modal-content text-sm">
          <div>
            <div className="text-info">{t('package.category')}</div>
            <div>{deal.roomType}</div>
          </div>
          <div className={'mb-20'} style={getTextAlignStyle(description.remarks)}>
            <div
              className="text-lh-sm"
              dangerouslySetInnerHTML={{ __html: description.remarks }}
            ></div>
          </div>
          <div>
            <div className="text-info">{t('package.taxes')}</div>
            <div>{description.taxes}</div>
          </div>
        </div>
        <div className="modal-footer">
          <Button title={t('close')} className="btn btn-default" onClick={() => onClose()} />
        </div>
      </div>
    </div>
  );
};

export default withErrorBoundary(MoreDetailsModal, 'MoreDetailsModal');
